import { CopilotMessage } from '../models/copilot.model'

interface PersistedToolCall {
  toolCallId: string;
  toolName: string;
  input: any;
  output: any;
  status: 'executed' | 'pending' | 'rejected' | 'error';
  duration_ms?: number;
}

interface PersistedMessage {
  _id?: string;
  id?: string;
  threadId: string;
  role: 'user' | 'assistant' | 'tool';
  content: string | null;
  createdAt: string;
  toolCalls?: PersistedToolCall[];
  attachmentRefs?: string[];
  usage?: any;
}

export function mapPersistedMessages(items: PersistedMessage[]): CopilotMessage[] {
  const result: CopilotMessage[] = []

  for (const msg of items) {
    const msgId = msg.id ?? msg._id ?? ''

    if (msg.role === 'user') {
      result.push({
        id: msgId,
        role: 'user',
        content: msg.content ?? '',
        createdAt: msg.createdAt,
      })
      continue
    }

    if (msg.role === 'assistant') {
      if (msg.content) {
        result.push({
          id: msgId,
          role: 'assistant',
          content: msg.content,
          createdAt: msg.createdAt,
        })
      }

      if (Array.isArray(msg.toolCalls)) {
        for (const tc of msg.toolCalls) {
          if (tc.status === 'executed') {
            const entityId = tc.output?.id ?? tc.output?._id ?? ''
            result.push({
              id: `${msgId}-tc-${tc.toolCallId}`,
              role: 'system',
              content: '',
              createdAt: msg.createdAt,
              actionToolName: tc.toolName,
              actionSuccess: true,
              actionResultId: entityId || undefined,
              preview: tc.input,
            })
          } else if (tc.status === 'rejected') {
            result.push({
              id: `${msgId}-tc-${tc.toolCallId}`,
              role: 'system',
              content: '',
              createdAt: msg.createdAt,
              actionToolName: tc.toolName,
              actionSuccess: false,
              actionError: '__rejected__',
            })
          } else if (tc.status === 'error') {
            result.push({
              id: `${msgId}-tc-${tc.toolCallId}`,
              role: 'system',
              content: '',
              createdAt: msg.createdAt,
              actionToolName: tc.toolName,
              actionSuccess: false,
              actionError: '__failed__',
            })
          }
          // 'pending' status — skip (expired/abandoned actions)
        }
      }
      continue
    }

    // role === 'tool' — skip (info already in assistant's toolCalls)
  }

  return result
}
